// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"163":"04634dea","235":"8c650585","312":"c9443120","810":"cee19718","864":"f6695fe2","885":"bfebfbf4","977":"7d63c55a"}[chunkId] + ".css";
};